import React from 'react';
import { Icon, IconComponent } from './icon';
import src from 'grpn-mx-mixer/dist/images/icons/recent-activity.svg';

export const IconRecentActivity: IconComponent = props => <Icon {...props} src={src} />;
